function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b_531_2216)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63.8601 35.43C63.8601 51.1319 51.1319 63.8601 35.43 63.8601C19.7281 63.8601 7 51.1319 7 35.43C7 19.731 19.7281 7 35.43 7C51.1319 7 63.8601 19.731 63.8601 35.43Z",
  fill: "url(#paint0_linear_531_2216)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter1_f_531_2216)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.6481 35.4032C53.6481 45.4011 45.5437 53.5056 35.5457 53.5056C25.5478 53.5056 17.4434 45.4011 17.4434 35.4032C17.4434 25.407 25.5478 17.3008 35.5457 17.3008C45.5437 17.3008 53.6481 25.407 53.6481 35.4032Z",
  fill: "#FFA019"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_b_531_2216)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.9997 46.5702C74.9997 62.2721 62.2716 75.0002 46.5697 75.0002C30.8678 75.0002 18.1396 62.2721 18.1396 46.5702C18.1396 30.8711 30.8678 18.1401 46.5697 18.1401C62.2716 18.1401 74.9997 30.8711 74.9997 46.5702Z",
  fill: "url(#paint1_linear_531_2216)"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M61.1107 34.8331C61.1107 32.0797 55.2898 29 47.4996 29C39.7095 29 33.8887 32.0797 33.8887 34.8331C33.8887 37.5866 39.7095 40.6663 47.4996 40.6663C55.2898 40.6663 61.1107 37.5866 61.1107 34.8331Z",
  fill: "url(#paint2_linear_531_2216)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8889 58.1668C33.8889 60.9201 39.7097 63.9999 47.4999 63.9999C55.29 63.9999 61.111 60.9201 61.111 58.1668V56.6152C60.5804 56.974 60 57.3126 59.369 57.6281C56.166 59.2296 51.9508 60.1115 47.4997 60.1115C43.0485 60.1115 38.833 59.2295 35.6303 57.6281C34.9995 57.3128 34.4191 56.974 33.8887 56.6154V58.1668H33.8889Z",
  fill: "url(#paint3_linear_531_2216)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8889 50.3888C33.8889 53.1423 39.7097 56.222 47.4999 56.222C55.29 56.222 61.111 53.1423 61.111 50.3888V48.8374C60.5804 49.196 60 49.5347 59.369 49.8501C56.166 51.4517 51.9506 52.3336 47.4997 52.3336C43.0485 52.3336 38.8331 51.4515 35.6303 49.8501C34.9995 49.5348 34.4191 49.196 33.8887 48.8377V50.3888H33.8889Z",
  fill: "url(#paint4_linear_531_2216)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8889 42.6111C33.8889 45.3645 39.7097 48.4441 47.4999 48.4441C55.29 48.4441 61.111 45.3645 61.111 42.6111V41.0596C60.5804 41.4183 60 41.757 59.369 42.0725C56.166 43.6741 51.9506 44.556 47.4997 44.556C43.0485 44.556 38.8331 43.674 35.6303 42.0725C34.9995 41.7571 34.4191 41.4184 33.8887 41.0598V42.6111H33.8889Z",
  fill: "url(#paint5_linear_531_2216)"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b_531_2216",
  x: -6,
  y: -6,
  width: 82.8604,
  height: 82.8599,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 6.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_531_2216"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_531_2216",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_531_2216",
  x: 0.443359,
  y: 0.300781,
  width: 70.2051,
  height: 70.2046,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.5,
  result: "effect1_foregroundBlur_531_2216"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_b_531_2216",
  x: -5.86035,
  y: -5.85986,
  width: 104.86,
  height: 104.86,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_531_2216"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_531_2216",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_531_2216",
  x1: 39.616,
  y1: 39.2376,
  x2: -10.3463,
  y2: 63.5304,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB651"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEBD61"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_531_2216",
  x1: 17.9998,
  y1: 20.5002,
  x2: 71.4998,
  y2: 75.0002,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE0B5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9500"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_531_2216",
  x1: 47.4997,
  y1: 29,
  x2: 47.4997,
  y2: 40.6663,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCD8A6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_531_2216",
  x1: 47.4998,
  y1: 56.6152,
  x2: 47.4998,
  y2: 63.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCD8A6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_531_2216",
  x1: 47.4998,
  y1: 48.8374,
  x2: 47.4998,
  y2: 56.222,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCD8A6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_531_2216",
  x1: 47.4998,
  y1: 41.0596,
  x2: 47.4998,
  y2: 48.4441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCD8A6"
})));

function SvgCoinsBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsBig);
export default __webpack_public_path__ + "assets/media/CoinsBig.554114ff.svg";
export { ForwardRef as ReactComponent };